<script>
  import dialogMixin from "./mixins/dialog";
  import formatDate from '@utils/format-date'
  export default {
    mixins: [dialogMixin],
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        tableData: [
          {
            year: '109',
            day: '110/08/14',
            stock: '-',
            money: '3.00066710元',
            tradingDay: '110/07/16',
            baseDate: '110/07/24',
            issuanceDate: '110/08/11',
          },
          {
            year: '108',
            day: '109/06/10',
            stock: '-',
            money: '2.01013223元',
            tradingDay: '109/06/10',
            baseDate: '109/06/16',
            issuanceDate: '109/07/03',
          },
          {
            year: '107',
            day: '108/06/13',
            stock: '-',
            money: '1.497073元',
            tradingDay: '108/06/28',
            baseDate: '108/07/06',
            issuanceDate: '108/07/25',
          },
          {
            year: '106',
            day: '107/06/11',
            stock: '-',
            money: '1.2996398元',
            tradingDay: '107/08/21',
            baseDate: '107/08/27',
            issuanceDate: '107/09/13',
          },
          {
            year: '105',
            day: '106/06/14',
            stock: '-',
            money: '1.19982678元',
            tradingDay: '106/08/22',
            baseDate: '106/08/28',
            issuanceDate: '106/09/15',
            href:"https://investor.tsmc.com/english/dividends/2016"
          },
        ]
      }
    },
    computed: {
      formattedList() {
        const result = this.tableData
        if(result.length > 5) {
          result.length = 5
        }
        return result;
      }
    },
    methods: {
      formatYearDate(date) {
        if(!date) {
          return ''
        }
        const format = date.split('/'); 
        const year = format[0] - 1911 ;
        format[0] = year > 0 ? year : 0;
        return format.length > 1 ? `${ format[0] }/${ format[1] }/${ format[2] }` : ''
      }
    }
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogAllocation }`"
    width="1300px"
    append-to-body
  >
    <div class="sectionTitle text-center mb-5 font-medium color-gray-7">近{{ list.length }}年股利分派表</div>
    <el-table
      :data="list"
      style="width:100%"
      class="mb-5 isStyleStock"
    >
      <el-table-column
        label="股利年度"
        width="120"
    >
        <template slot-scope="scope">
          <a v-if="scope.row.href" :href="scope.row.href" class="link">
            {{ scope.row.year }}
          </a>
          <div v-else style="text-decoration: underline;">
            {{ scope.row.year }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="meeting-date"
        label="股東會日期"
        width="170"
      >
        <template slot-scope="scope">
          {{formatYearDate(scope.row['meeting-date'])}}
        </template>
      </el-table-column>
      <el-table-column label="每股配發股利">
        <el-table-column
          prop="dividend-stock"
          label="股票股利"
        >
        </el-table-column>
        <el-table-column
          prop="dividend-cash"
          label="現金股利(新台幣)"
          width="220"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="除權息交易日"
        width="170"
      >
        <template slot-scope="scope">
          {{formatYearDate(scope.row['ex-dividend-date'])}}
        </template>
      </el-table-column>
      <el-table-column
        label="除權息基準日"
        width="170"
      >
        <template slot-scope="scope">
          {{formatYearDate(scope.row['ex-dividend-base-date'])}}
        </template>
      </el-table-column>
      <el-table-column
        label="股利發放日"
        width="170"
      >
        <template slot-scope="scope">
          {{formatYearDate(scope.row['payment-date'])}}
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogAllocation {
    :global {
      .sectionTitle {
        font-size: 24px;
      }
      .link {
        color: $color-gray-7;
        text-decoration: underline;
        &:hover{ 
          color: $color-gray-6;
        }
      }
    }
  }
</style>
